import Vue from 'vue';
import Router from 'vue-router';
import Public from './public/Public.vue';
import Login from './public/Login.vue';
import Forgot from './password-reset/Forgot.vue';
import ResetPW from './password-reset/ResetPW.vue';
import Secure from './secure/Secure.vue';
import Dashboard from './secure/Dashboard.vue';
import Users from './secure/Users.vue';
import Media from './secure/Media.vue';

import {SNACK_ACTION} from '@/_store/snackbar';
import {store} from '@/_store';
import {account, ACCOUNT_ACTION} from "@/_store/account";
import {getTokenFromCookie} from "@/_helpers/http";

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/public',
      name: 'public',
      component: Public,
      children: [
        {
          path: 'login',
          component: Login,
          meta: {
            title: 'Log In',
          },
        },
        {
          path: 'forgot',
          component: Forgot,
          meta: {
            title: 'Forgot Password',
          },
        },
        {
          path: 'reset',
          component: ResetPW,
          meta: {
            title: 'Reset Password',
          },
        },
        { path: '*', redirect: '/public/login' },
      ],
    },
    {
      path: '/secure',
      name: 'secure',
      component: Secure,
      children: [
        // {
        //   path: 'dashboard',
        //   component: Dashboard,
        //   meta: {
        //     title: 'Dashboard',
        //   },
        // },
        {
          path: 'media',
          component: Media,
          meta: {
            title: 'Media Library',
          },
        },
        {
          path: 'users',
          component: Users,
          meta: {
            title: 'Manage Users',
          },
        },
        { path: '*', redirect: '/secure/media' },
      ],
    },
    { path: '*', redirect: '/public/login' },
  ],

});


router.beforeEach(async (to, from, next) => {
  let isAuthenticated: boolean = store.getters[ACCOUNT_ACTION.IS_AUTHENTICATED];
  const token = getTokenFromCookie();

  if (!isAuthenticated && token) {
    await store.dispatch(ACCOUNT_ACTION.SELF);
    isAuthenticated = store.getters[ACCOUNT_ACTION.IS_AUTHENTICATED];
  }

  if (isAuthenticated) {
    if (to.path.toLowerCase().indexOf("/public") === 0) {
      return router.push("/secure/dashboard");
    }
  }

  if (!isAuthenticated) {
    if (to.path.toLowerCase().indexOf("/secure") === 0) {
      return router.push("/public/login");
    }
  }

  // Clear any snackbars
  store.dispatch(SNACK_ACTION.CLEAR);

  // Switch title
  document.title = to.meta.title + ' | BEM Creative';
  next();
});

export default router;
